<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div class="ufv-container-text">
            <div class="text-h4">Área Administrativa</div>
        </div>
        <div
            v-if="loading"
            class="my-8 align-self-stretch d-flex align-center justify-center"
        >
            <spinner />
        </div>
        <div
            v-if="!loading"
            class="my-6 flex-grow-1"
            style="border: 0px solid red"
        >
            <div>
                <router-link :to="{ name: 'ListaContextos' }"
                    >Contextos</router-link
                >
            </div>

            <div v-if="isSuperAdmin">
                <router-link :to="{ name: 'UsuarioInstitucionalAdmin' }"
                    >Usuários Institucionais</router-link
                >
            </div>
        </div>
    </v-container>
</template>

<script>
import Spinner from "../../componentes/ui/Spinner";
import { mapGetters } from "vuex";

export default {
    components: { Spinner },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapGetters("autenticacao", ["isSuperAdmin"]),
    },
};
</script>

<style scoped>
item {
    margin: 5px;
    padding: 5px;
}
</style>
